import { render, staticRenderFns } from "./HemocirButton.vue?vue&type=template&id=72bc86d3&scoped=true&functional=true&"
import script from "./HemocirButton.vue?vue&type=script&lang=js&"
export * from "./HemocirButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "72bc86d3",
  null
  
)

export default component.exports